import React from "react";

const JobOpenings = () => {
    return <div>Job Openings</div>;
};

export default JobOpenings;